<script>
    export let code;
</script>

<style>
    .square {
        height: 30px;
        width: 30px;
        line-height: 30px;

        margin: .2em;
        
        display: inline-block;
        
        text-align: center;
        background-color: #211e27;
        
        font-size: 100%;
        
        border: 1px solid #d7f869;
        
        box-sizing: border-box;
    }
</style>

<div class="square">
    {#if code}
        {code}
    {:else}
        _
    {/if}
</div>